import { IMAGES } from "@/data/site";

// City metadata used to build each unit (Matriz / Filial) page.
const CITIES = [
  {
    slug: "pimenta-bueno", city: "Pimenta Bueno", uf: "RO", kind: "Matriz",
    lat: -11.6725, lng: -61.1936, image: IMAGES.hero,
    econ: "cidade estratégica no centro-sul de Rondônia", road: "BR-364",
    extra: "É aqui que fica a sede administrativa e operacional da Auto Socorro Pimenta, de onde coordenamos boa parte das operações na região.",
    also: ["Rolim de Moura", "Cacoal", "São Miguel do Guaporé", "Colorado do Oeste"],
  },
  {
    slug: "vilhena", city: "Vilhena", uf: "RO", kind: "Filial",
    lat: -12.7404, lng: -60.1458, image: IMAGES.cattleTrailer,
    econ: "principal entroncamento na divisa de Rondônia com Mato Grosso", road: "BR-364",
    extra: "Vilhena é um corredor logístico de intenso fluxo de caminhões e carretas, o que torna o guincho pesado essencial na região.",
    also: ["Comodoro", "Colorado do Oeste", "Cerejeiras"],
  },
  {
    slug: "colorado-do-oeste", city: "Colorado do Oeste", uf: "RO", kind: "Filial",
    lat: -13.1174, lng: -60.5453, image: IMAGES.highwayRescue,
    econ: "região agropecuária no cone sul de Rondônia", road: "BR-435 e RO-399",
    extra: "A forte presença da pecuária e da agricultura gera demanda constante por reboque de veículos e transporte de máquinas.",
    also: ["Vilhena", "Cerejeiras", "Cabixi", "Pimenteiras do Oeste"],
  },
  {
    slug: "cacoal", city: "Cacoal", uf: "RO", kind: "Filial",
    lat: -11.4343, lng: -61.4562, image: IMAGES.fleetDirtLot,
    econ: "um dos maiores polos comerciais e de saúde da região", road: "BR-364",
    extra: "A grande movimentação urbana e rodoviária exige um serviço de auto socorro ágil e disponível 24 horas.",
    also: ["Rolim de Moura", "Pimenta Bueno", "Ministro Andreazza", "Espigão do Oeste"],
  },
  {
    slug: "sao-miguel-do-guapore", city: "São Miguel do Guaporé", uf: "RO", kind: "Filial",
    lat: -11.6957, lng: -62.7178, image: IMAGES.heroFleet,
    econ: "região do Vale do Guaporé", road: "RO-010 e BR-429",
    extra: "É uma área de forte atividade agropecuária, com necessidade frequente de resgate de veículos e transporte de implementos.",
    also: ["São Francisco do Guaporé", "Seringueiras", "Nova Brasilândia d'Oeste"],
  },
  {
    slug: "ji-parana", city: "Ji-Paraná", uf: "RO", kind: "Filial",
    lat: -10.8853, lng: -61.9517, image: IMAGES.hero,
    econ: "segunda maior cidade de Rondônia e importante polo industrial", road: "BR-364",
    extra: "O intenso tráfego de veículos leves e pesados faz do atendimento rápido um diferencial decisivo.",
    also: ["Ouro Preto do Oeste", "Presidente Médici", "Jaru"],
  },
  {
    slug: "ouro-preto-do-oeste", city: "Ouro Preto do Oeste", uf: "RO", kind: "Filial",
    lat: -10.7482, lng: -62.2159, image: IMAGES.highwayRescue,
    econ: "região central de Rondônia", road: "BR-364",
    extra: "A produção agropecuária e leiteira movimenta a economia local e demanda suporte constante nas estradas.",
    also: ["Ji-Paraná", "Jaru", "Mirante da Serra", "Vale do Paraíso"],
  },
  {
    slug: "jaru", city: "Jaru", uf: "RO", kind: "Filial",
    lat: -10.4392, lng: -62.4664, image: IMAGES.cattleTrailer,
    econ: "importante município do centro-leste de Rondônia", road: "BR-364",
    extra: "O comércio ativo e a agropecuária geram fluxo constante de veículos que precisam de assistência.",
    also: ["Ouro Preto do Oeste", "Ji-Paraná", "Governador Jorge Teixeira", "Theobroma"],
  },
  {
    slug: "sapezal", city: "Sapezal", uf: "MT", kind: "Filial",
    lat: -13.5423, lng: -58.8138, image: IMAGES.fleetDirtLot,
    econ: "um dos maiores polos do agronegócio de Mato Grosso", road: "MT-235 e MT-388",
    extra: "A grande circulação de máquinas agrícolas e cargas torna o transporte de máquinas um dos serviços mais procurados.",
    also: ["Campos de Júlio", "Comodoro", "Campo Novo do Parecis"],
  },
  {
    slug: "campos-de-julio", city: "Campos de Júlio", uf: "MT", kind: "Filial",
    lat: -13.7647, lng: -59.2706, image: IMAGES.heroFleet,
    econ: "município agrícola da Chapada dos Parecis", road: "MT-235",
    extra: "A produção de grãos em larga escala exige transporte de máquinas e implementos com segurança e agilidade.",
    also: ["Sapezal", "Comodoro", "Campo Novo do Parecis"],
  },
  {
    slug: "comodoro", city: "Comodoro", uf: "MT", kind: "Filial",
    lat: -13.6616, lng: -59.7871, image: IMAGES.highwayRescue,
    econ: "cidade na divisa de Mato Grosso com Rondônia", road: "BR-174",
    extra: "O agronegócio e a pecuária em expansão aumentam a demanda por guincho pesado e assistência rodoviária.",
    also: ["Campos de Júlio", "Sapezal", "Nova Lacerda", "Vilhena"],
  },
];

function buildKeywords(city) {
  return [
    `Guincho ${city}`,
    `Auto Socorro ${city}`,
    `Guincho 24 horas ${city}`,
    `Reboque ${city}`,
    "Guincho Leve",
    "Guincho Pesado",
    "Transporte de Máquinas",
  ];
}

function buildIntro(c) {
  if (c.kind === "Matriz") {
    return `A Matriz da Auto Socorro Pimenta fica em ${c.city}, ${c.econ}. Há mais de 20 anos coordenamos daqui os serviços de guincho, auto socorro e transporte de máquinas em Rondônia e Mato Grosso, com atendimento rápido e seguro 24 horas por dia.`;
  }
  return `A filial da Auto Socorro Pimenta em ${c.city} atende a cidade e toda a região, ${c.econ}, com serviços completos de guincho leve, guincho pesado, transporte de máquinas e auto socorro 24 horas.`;
}

function buildParagraphs(c) {
  const also = c.also.join(", ");
  return [
    `Se você procura guincho em ${c.city}, a Auto Socorro Pimenta é a escolha certa. Com mais de 20 anos de experiência em Rondônia e Mato Grosso, oferecemos guincho leve, guincho pesado, transporte de máquinas, assistência rodoviária e auto socorro 24 horas. Nossa estrutura garante atendimento ágil tanto na área urbana de ${c.city} quanto nas rodovias que cortam a região, como a ${c.road}.`,
    `O auto socorro em ${c.city} funciona 24 horas por dia, todos os dias do ano. Emergências com veículos não têm hora para acontecer, e por isso mantemos nossa equipe de prontidão de dia e de noite, inclusive em feriados e finais de semana. Uma ligação ou mensagem de WhatsApp é o suficiente para acionar o guincho mais próximo de você.`,
    `Nosso guincho leve em ${c.city} atende carros de passeio, motos, utilitários e veículos comerciais leves. Utilizamos plataformas modernas e sistemas de fixação seguros para transportar o seu veículo sem qualquer dano. Panes mecânicas, falhas elétricas, acidentes e problemas com pneus são resolvidos com rapidez e cuidado pela nossa equipe.`,
    `Para veículos de grande porte, oferecemos o guincho pesado em ${c.city}, com caminhões guincho de alta capacidade preparados para o reboque e o resgate de caminhões, carretas, ônibus e máquinas. ${c.extra}`,
    `O transporte de máquinas em ${c.city} é ideal para empresas, indústrias e produtores rurais que precisam movimentar cargas pesadas, implementos, equipamentos, estruturas metálicas e containers. Realizamos cada operação com caminhão munck e pranchas apropriadas, sempre com segurança e precisão no manuseio das cargas.`,
    `Além de ${c.city}, a nossa equipe atende as cidades vizinhas de ${also}, entre outras localidades da região. Essa cobertura ampla é possível graças à nossa frota completa e à localização estratégica das nossas unidades, o que nos permite reduzir o tempo de deslocamento e chegar mais rápido até você.`,
    `Também somos parceiros de seguradoras, oferecendo remoção e resgate de veículos segurados com agilidade e a documentação adequada. As seguradoras que atuam em ${c.city} contam com a Auto Socorro Pimenta para garantir um atendimento de qualidade aos seus segurados, 24 horas por dia.`,
    `Com mais de 20 anos de estrada, construímos uma reputação sólida baseada em agilidade, segurança e respeito ao cliente. Atendemos com transparência e preço justo, e é por isso que somos referência em guincho e auto socorro em ${c.city}. Se você precisa de guincho 24 horas, entre em contato pelo WhatsApp ou telefone — nossa equipe está pronta para atender você.`,
  ];
}

export const FILIAIS = CITIES.reduce((acc, c) => {
  acc[c.slug] = {
    slug: c.slug,
    path: `/filial/${c.slug}`,
    city: c.city,
    uf: c.uf,
    kind: c.kind,
    lat: c.lat,
    lng: c.lng,
    image: c.image,
    seoTitle: `Guincho em ${c.city} ${c.uf} | Auto Socorro 24 Horas | Guincho Leve, Pesado e Transporte de Máquinas`,
    seoDescription: `Guincho 24 horas em ${c.city} (${c.uf}): guincho leve, guincho pesado, auto socorro e transporte de máquinas. A Auto Socorro Pimenta também atende ${c.also.join(", ")}.`,
    keywords: buildKeywords(c.city),
    also: c.also,
    intro: buildIntro(c),
    paragraphs: buildParagraphs(c),
  };
  return acc;
}, {});

export const MATRIZ = FILIAIS["pimenta-bueno"];
export const FILIAIS_RO = CITIES.filter((c) => c.uf === "RO" && c.kind !== "Matriz").map((c) => FILIAIS[c.slug]);
export const FILIAIS_MT = CITIES.filter((c) => c.uf === "MT").map((c) => FILIAIS[c.slug]);
export const ALL_UNITS = CITIES.map((c) => FILIAIS[c.slug]);
